import React from 'react';
import HomePage from './HomePage';
import './App.css';

function App() {
  return (
    <div className="App">
        <HomePage />
    </div>
  );
}

export default App;
